<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          韩国填表
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询姓名,护照号,所有者..." v-model="queryParam.searchValue" @change="search"
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
    </Tool>
    <div class="content">
      <div style="margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between">
        <div>
          <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">新增</a-button>
          <a-button type="primary" icon="download" :disabled="!hasSelected" style="margin-left: 10px"
                    @click="handleDownloads">
            批量导出
          </a-button>
        </div>
      </div>

      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          bordered
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
        <template slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleLink(record)">外链</a>
          <a-divider type="vertical"/>
          <a @click="handleDownload(record.id)">导出</a>
        </template>
      </a-table>
    </div>
    <CreateModal ref="createModal" @ok="loadData"></CreateModal>
    <DetailCreateModal ref="detailCreateModal" @ok="loadData"></DetailCreateModal>
  </div>

</template>

<script>

import Tool from '@/components/Tool.vue'
import {HttpMixins} from "@/mixins/http-mixins";
import {TableMixins} from "@/mixins/table-mixins";
import debounce from "lodash/debounce";
import CreateModal from "@/components/krDs/CreateModal.vue";
import DetailCreateModal from "@/components/krDs/DetailCreateModal.vue";

export default {
  name: "ThaDs",
  components: {
    Tool,
    CreateModal,
    DetailCreateModal,
  },
  mixins: [HttpMixins, TableMixins],
  data() {
    return {
      queryParam: {
        searchValue: ''
      },
      columns: [
        {
          title: '身份证号',
          align: "center",
          dataIndex: 'idcard',
        },
        {
          title: '护照号',
          align: "center",
          dataIndex: 'passport',
        },
        {
          title: '姓名',
          align: "center",
          dataIndex: 'chineseName',
        },
        {
          title: '姓(拼音)',
          align: "center",
          dataIndex: 'lastName',
        },
        {
          title: '名(拼音)',
          align: "center",
          dataIndex: 'firstName',
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '所有者',
          align: "center",
          dataIndex: 'user'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        list: window._CONFIG['domainURL'] + "/krDs/list",
        export: window._CONFIG['domainURL'] + "/krDs/export"
      }
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    search: debounce(function () {
      this.pagination.current = 1;
      this.loadData();
    }, 800),
    handleEdit(record) {
      this.$refs.createModal.show(record);
    },
    handleAdd() {
      this.$refs.createModal.show();
    },
    handleDownloads() {
      let that = this;
      for (let i = 0; i < that.selectedRowKeys.length; i++) {
        if (i === 0) {
          window.location.href = that.url.export + "?id=" + that.selectedRowKeys[i];
          continue;
        }
        setTimeout(function () {
          window.location.href = that.url.export + "?id=" + that.selectedRowKeys[i];
        }, 3000 + i * 1000);
      }
    },
    handleLink(record) {
      let url = window._CONFIG['homeURL'] + "/#/krDsLink?timetamp=" + (new Date()).getTime() + "&id=" + record.id;
      this.$info({
        title: record.chineseName + '-外链填表',
        width: 500,
        content: (
            <div>
              <a href={url} target="_blank">{url}</a>
            </div>
        ),
      });
    },
    handleDownload(id) {
      window.location.href = this.url.export + "?id=" + id;
    },
  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>